import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDrawerState } from "./drawerModel";

const initialState: IDrawerState = {
  open: false,
  anchor: "left",
  drawerWidth: 250,
  name: "muidrawer",
  data: null,
  label: "",
};

export type Anchor = "top" | "left" | "bottom" | "right";

const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    opened: (state, action: PayloadAction<IDrawerState>) => {
      state.open = action.payload.open;
      state.anchor = action.payload.anchor;
      state.drawerWidth = action.payload.drawerWidth
        ? action.payload.drawerWidth
        : state.drawerWidth;
      state.name = action.payload.name;
      state.data = action.payload.data ? action.payload.data : null;
      state.label = action.payload.label ? action.payload.label : "";
    },
    closed: (state) => {
      state.open = false;
      state.name = "drawer";
      state.data = null;
    },
  },
});

export default drawerSlice.reducer;
export const { opened, closed } = drawerSlice.actions;
